import React, {useEffect, useRef, useState} from "react";
import {
    Card,
    Grid,
    Typography,
    Button,
    Box,
    useTheme,
    useMediaQuery,
    PropTypes as MuIPropTypes,
    CircularProgress, InputBase,
} from "@material-ui/core";
import {ChromePicker} from "react-color";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "formik-material-ui";
import {Formik, Form, Field} from "formik";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {colorBorder, colorSecondary} from "../../Constants/theme";
import {ReactComponent as PencilSVG} from "../../Images/pencil.svg";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";
import UploadPhoto from "../Modals/UploadPhoto";
import API from "../../helpers/apiHelpers";
import {useSelector} from "react-redux";
import {
    getPartner,
    getPartnerURLUploadLogo, getUsersBranding, updatePartner
} from "../../redux/branding/branding.actions";
import {RootState, useAppDispatch} from "../../redux/store";
import FontsInput from "../Fields/FontsInput";
import {appURL} from "../../Constants/api";
import {getUserByID} from "../../redux/user/user.actions";
import moment from "moment";

const useStyle = makeStyles(() => ({
    wrapper: {
        padding: "2em 1em 2em 2em"
    },
    formItem: {
        marginBottom: "1em",
    },
    logo: {
        marginTop: "3em",
        marginBottom: "4em"
    },
    inputGroup: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    colorInput: {
        padding: 0,
        border: "none",
        "-webkit-appearance": "none",
        height: "48px",
        opacity: 0,
        cursor: "pointer"
    },
    popover: {
        position: "absolute",
        zIndex: 2
    },
    cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
    }
}));

const PreferencesForm = () => {
    const classes = useStyle();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const branding = useSelector((state: RootState) => state?.branding);
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [uploadPhotoURL, setUploadPhotoUrl] = useState("");
    const [linkToImage, setLinkToImage] = useState("");
    const {enqueueSnackbar} = useSnackbar();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const textAlignmentAdaptive: MuIPropTypes.Alignment = isMobile ? "left" : "left";
    let initialValues = {
        url: null,
        brandHeader: colorBorder,
        brandText: colorBorder,
        buttonText: colorBorder,
        brandAccent: colorSecondary,
        headerFont: "",
        textFont: ""
    };
    const [formikValues, setFormikValues] = useState(initialValues);
    const [isLoaderShowed, setIsLoaderShowed] = useState(false);
    const [downloadId, setDownloadId] = useState(0);
    const imageRef = useRef(null);
    const handleImageLoadError = () => {
        setLinkToImage("");
    };
    const validationSchema = Yup.object().shape({
        // logo: Yup.string().required("Required"),
        // brandHeader: Yup.string().required("Required"),
        // brandText: Yup.string().required("Required"),
        // brandAccent: Yup.string().required("Required"),
        // headerFont: Yup.string().required("Required"),
        // textFont: Yup.string().required("Required")
    });
    const user = useSelector((state: RootState) => state?.user);


    useEffect(() => {
        (async () => {
            setIsLoaderShowed(true);
            if (user.userId) {
                try {
                    const res = await dispatch(getUserByID(user.userId));
                    if (res?.partnerEntity?.id) {
                        await dispatch(getPartner(res?.partnerEntity?.id));
                    } else {
                        await dispatch(getUsersBranding());
                    }
                    setFormikValues({
                        url: branding.url,
                        brandHeader: branding.brandHeader,
                        brandText: branding.brandText,
                        buttonText: branding.buttonText,
                        brandAccent: branding.brandAccent,
                        headerFont: branding.headerFont,
                        textFont: branding.textFont
                    });
                    setDownloadId(+branding.partnerId);
                    setLinkToImage(branding.logo);
                    dispatch(getPartnerURLUploadLogo(branding.partnerId)).then(res =>
                        setUploadPhotoUrl(res.uploadUrl));
                    setIsLoaderShowed(false);
                } catch {
                    enqueueSnackbar("Partner doesn't exist for this user", {
                        variant: "error",
                    });
                    setIsLoaderShowed(false);
                }
            }
        })();
    }, []);

    return (
        <Formik
            initialValues={formikValues}
            enableReinitialize
            onSubmit={async (values) => {
                try {
                    let body = {
                        name: branding.name,
                        url: values.url,
                        color: {
                            header: values.brandHeader,
                            text: values.brandText,
                            accent: values.brandAccent,
                            buttonText: values.buttonText,
                        },
                        font: {
                            header: values.headerFont,
                            text: values.textFont
                        }
                    };
                    await dispatch(updatePartner({id: downloadId, body}));
                    enqueueSnackbar("Preferences are saved.", {
                        autoHideDuration: 2500
                    });
                } catch (error) {
                    enqueueSnackbar(error, {
                        variant: "error",
                        autoHideDuration: 3000,
                    });

                }
            }}
            validationSchema={validationSchema}
        >
            {
                ({
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue
                }) => {

                    return (
                        <Form>
                            <Card variant="outlined">
                                {/* Desiding if we want to show form or loader */}
                                {
                                    !isLoaderShowed ?
                                        <Grid container className={classes.wrapper}>
                                            <Grid item container justify="space-between" alignItems="center">
                                                <Grid container alignItems="center" item xs={12}>
                                                    <Box marginBottom="10px">
                                                        <Typography variant="h4">Branding</Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid item container alignItems="center" className={classes.logo}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box marginBottom="20px">
                                                            <Typography variant="subtitle1"
                                                                align={textAlignmentAdaptive}
                                                                style={{fontWeight: 700}}>Logo</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid xs={12} sm={6} item justify="center">
                                                        <Box position="relative" width="70%">
                                                            {
                                                                <Box
                                                                    position="absolute"
                                                                    right="-10px"
                                                                    bottom="-9px"
                                                                    borderRadius="50%"
                                                                    bgcolor={branding.brandAccent}
                                                                    width="21px"
                                                                    style={{cursor: "pointer"}}
                                                                    height="21px"
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    onClick={() => {
                                                                        setUploadPhotoModalVisibility(true);
                                                                    }}
                                                                >
                                                                    <PencilSVG/>
                                                                </Box>
                                                            }
                                                            {
                                                                linkToImage ?
                                                                    <img
                                                                        alt="brand logo" 
                                                                        ref={imageRef}
                                                                        src={linkToImage}
                                                                        onError={handleImageLoadError}
                                                                        width="100%"
                                                                        style={{objectFit: "cover"}}
                                                                    />
                                                                    :
                                                                    <LogoSVG/>
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                <Grid item container alignItems="center" className={classes.formItem}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box marginBottom="10px">
                                                            <Typography variant="subtitle1"
                                                                align={textAlignmentAdaptive}
                                                                style={{fontWeight: 700}}>Brand
                                                                Header</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Field
                                                            component={ColorPicker}
                                                            variant="outlined"
                                                            fullWidth
                                                            name="brandHeader"
                                                            id="brandHeader"
                                                            aria-labelledby="brand Header"
                                                            type="color"
                                                            onChange={handleChange("brandHeader")}
                                                            onBlur={handleBlur("brandHeader")}
                                                            value={values.brandHeader}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item container alignItems="center" className={classes.formItem}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box marginBottom="10px">
                                                            <Typography variant="subtitle1"
                                                                align={textAlignmentAdaptive}
                                                                style={{fontWeight: 700}}>Brand
                                                                Text</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Field
                                                            component={ColorPicker}
                                                            variant="outlined"
                                                            fullWidth
                                                            id="brandText"
                                                            aria-labelledby="brand text"
                                                            name="brandText"
                                                            type="color"
                                                            onChange={handleChange("brandText")}
                                                            onBlur={handleBlur("brandText")}
                                                            value={values.brandText}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item container alignItems="center" className={classes.formItem}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box marginBottom="10px">
                                                            <Typography variant="subtitle1"
                                                                align={textAlignmentAdaptive}
                                                                style={{fontWeight: 700}}>Brand
                                                                Accent</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Field
                                                            component={ColorPicker}
                                                            variant="outlined"
                                                            fullWidth
                                                            name="brandAccent"
                                                            id="brandAccent"
                                                            aria-labelledby="brand accent"
                                                            type="color"
                                                            onChange={handleChange("brandAccent")}
                                                            onBlur={handleBlur("brandAccent")}
                                                            value={values.brandAccent}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item container alignItems="center" className={classes.formItem}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box marginBottom="10px">
                                                            <Typography variant="subtitle1"
                                                                align={textAlignmentAdaptive}
                                                                style={{fontWeight: 700}}>Brand
                                                                Button Text</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Field
                                                            component={ColorPicker}
                                                            variant="outlined"
                                                            fullWidth
                                                            name="buttonText"
                                                            id="buttonText"
                                                            aria-labelledby="brand button text"
                                                            type="color"
                                                            onChange={handleChange("buttonText")}
                                                            onBlur={handleBlur("buttonText")}
                                                            value={values.buttonText}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item container alignItems="center" className={classes.formItem}>
                                                <Grid item xs={12} sm={6}>
                                                    <Box marginBottom="10px">
                                                        <Typography variant="subtitle1" align={textAlignmentAdaptive}
                                                            style={{fontWeight: 700}}>Header Font</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Field
                                                        component={FontsInput}
                                                        isFullWidth
                                                        type="text"
                                                        name="headerFont"
                                                        variant="outlined"
                                                        fullWidth
                                                        label="Choose font"
                                                        id="headerFont"
                                                        aria-labelledby="Choose header font"
                                                        onChange={handleChange("headerFont")}
                                                        handleChange={handleChange("headerFont")}
                                                        onBlur={handleBlur("headerFont")}
                                                        value={values.headerFont}
                                                        select={true}
                                                        margin="dense"
                                                        SelectProps={{
                                                            multiple: false,
                                                            style: {
                                                                height: 48
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container alignItems="center" className={classes.formItem}>
                                                <Grid item xs={12} sm={6}>
                                                    <Box marginBottom="10px">
                                                        <Typography variant="subtitle1" align={textAlignmentAdaptive}
                                                            style={{fontWeight: 700}}>Text Font</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Field
                                                        component={FontsInput}
                                                        isFullWidth
                                                        type="text"
                                                        name="textFont"
                                                        id="textFont"
                                                        aria-labelledby="Choose text font"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        label="Choose font"
                                                        onChange={handleChange("textFont")}
                                                        handleChange={handleChange("textFont")}
                                                        onBlur={handleBlur("textFont")}
                                                        value={values.textFont}
                                                        select={true}
                                                        SelectProps={{
                                                            multiple: false,
                                                            style: {
                                                                height: 48
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container alignItems="center" className={classes.formItem}>
                                                <Grid item xs={12} sm={6}>
                                                    <Box marginBottom="10px">
                                                        <Typography variant="subtitle1" align={textAlignmentAdaptive}
                                                            style={{fontWeight: 700}}>Unique URL</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Field
                                                        component={TextField}
                                                        isFullWidth
                                                        type="text"
                                                        id="url"
                                                        aria-labelledby="url"
                                                        name="url"
                                                        variant="outlined"
                                                        fullWidth
                                                        onChange={handleChange("url")}
                                                        handleChange={handleChange("url")}
                                                        onBlur={handleBlur("url")}
                                                        value={values.url}
                                                        margin="dense"
                                                        disabled
                                                        InputProps={{
                                                            style: {
                                                                height: 48
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container justify="flex-end">
                                                    <Button variant="contained" fullWidth={isMobile} color="primary"
                                                        type="submit">Save</Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        :
                                        <Box height="400px" width="100%" display="flex" justifyContent="center"
                                            alignItems="center">
                                            <CircularProgress/>
                                        </Box>
                                }
                            </Card>
                            {
                                uploadPhotoURL &&
                                <UploadPhoto
                                    onClose={() => {
                                        setUploadPhotoModalVisibility(false);
                                    }}
                                    isOpen={uploadPhotoModalVisibility}
                                    imageUploadURL={uploadPhotoURL}
                                    onLoad={(val) => {
                                        dispatch(getPartnerURLUploadLogo(downloadId))
                                            .then((res) => {
                                                setLinkToImage(res.downloadUrl);
                                                setUploadPhotoUrl(res.uploadUrl);
                                            });
                                        setUploadPhotoModalVisibility(false);
                                    }}
                                />
                            }
                        </Form>
                    );
                }
            }
        </Formik>
    );
};

const ColorPicker = (props) => {
    const classes = useStyle();
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState(props.value);
    const handleClick = () => {
        setOpen(!open);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Card variant="outlined">
                <Grid container alignItems="center">
                    <Grid item xs={4} style={{
                        backgroundColor: color,
                        height: "48px",
                        borderRadius: "4px 0 0 4px",
                        cursor: "pointer"
                    }} onClick={handleClick}>
                        {/*<InputBase*/}
                        {/*	type="color"*/}
                        {/*	fullWidth*/}
                        {/*	classes={{input: classes.colorInput}}*/}
                        {/*	{...props}*/}
                        {/*/>*/}
                    </Grid>
                    <Grid item xs={8}>
                        <Typography align="center">{color.toUpperCase()}</Typography>
                    </Grid>
                </Grid>
            </Card>
            {open ?
                <div className={classes.popover}>
                    <div className={classes.cover} onClick={handleClose}/>
                    <ChromePicker
                        color={color}
                        onChangeComplete={(color) => {
                            props.onChange(color.hex);
                        }}
                        onChange={(color) => setColor(color.hex)}
                    />
                </div> : null}
        </>
    );
};
export default PreferencesForm;
